<template lang="pug">
#wt-full-page-loader
  .spinner
    WtSvgIcon(
      style="width:48px; height:48px;"
      icon="map-loader"
      height="48px"
      width="48px"
    )
  .loading-text Loading...
</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon.vue";

export default {
  name: "WtFullPageLoader",
  components: {
    WtSvgIcon
  }
};
</script>

<style lang="sass" scoped>
#wt-full-page-loader
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  background: white
  z-index: 1000

  .spinner
    width: 48px
    height: 48px
    display: flex
    align-items: center
    justify-content: center
    animation: spin 2s infinite linear
    transform-origin: center

  .loading-text
    margin-top: 5px
    font-family: Manrope
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #416BA9

@keyframes spin
  100%
    transform: rotate(360deg)
</style>
